import React, { useRef } from 'react'
import useTemplateSuggestions from '../../../common/hooks/useTemplateSuggestions'
import styles from './index.module.scss'
import { useFlags } from 'launchdarkly-react-client-sdk'
import SuggestionsDropdownPortal from './components/SuggestionsDropdownPortal'
import SuggestionsFound from './components/SuggestionsFound'

const TemplateSuggestion = ({
  children,
  templates = [],
  onViewAllTemplates,
  minCharacters = 3,
  maxVisibleSuggestions = 3,
  audienceFilter = null, // 'everyone', 'internal', or null for all
  showPreApprovedOnly = false,
  className = '',
  // Props for input handling
  inputValue = '',
  onTemplateSelect,
  selectedTemplate,
  isUnifiedConversation,
  isEnabled,
  ...props
}) => {
  const containerRef = useRef(null)
  const flags = useFlags() || {}

  const {
    setShowSuggestions,
    showSuggestions,
    suggestedTemplates,
    handleTemplateSelect: selectTemplate,
    handleViewAllTemplates: viewAllTemplates,
    resetSuggestions,
  } = useTemplateSuggestions({
    templates,
    audienceFilter,
    showPreApprovedOnly,
    minCharacters,
    maxVisibleSuggestions,
    inputValue,
    onTemplateSelect,
  })

  // Handle template selection
  const handleTemplateSelectWrapper = (template) => {
    selectTemplate(template)
    resetSuggestions()
  }

  // Handle view all templates
  const handleViewAllTemplatesWrapper = () => {
    viewAllTemplates(onViewAllTemplates)
    resetSuggestions()
  }

  if (selectedTemplate || !flags?.useTemplateSuggestion || !isEnabled) {
    return children
  }

  return (
    <div ref={containerRef} className={`${styles.templateSuggestionWrapper} ${className}`} {...props}>
      <div className={styles.inputWrapper}>
        {children}
      </div>
      <SuggestionsFound
        suggestionsAmount={suggestedTemplates.length}
        showSuggestions={showSuggestions}
        setShowSuggestions={setShowSuggestions}
      />
      <SuggestionsDropdownPortal
        showSuggestions={showSuggestions}
        suggestedTemplates={suggestedTemplates}
        maxVisibleSuggestions={maxVisibleSuggestions}
        onTemplateSelect={handleTemplateSelectWrapper}
        onViewAllTemplates={handleViewAllTemplatesWrapper}
        containerRef={containerRef}
        setShowSuggestions={setShowSuggestions}
        isUnifiedConversation={isUnifiedConversation}
      />
    </div>
  )
}

export default TemplateSuggestion
